// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1ZBlr","addWidgetButton":"Header_addWidgetButton__1A8qg","dashboardTabs":"Header_dashboardTabs__2Wp48","active":"Header_active__3qFmY"};